export default __webpack_public_path__ + "static/media/ep2-poster-from-spaceship.738cfb3f.jpg";